import { BASEURL } from '../constants'

export const getBaseURL = () => {
  if (BASEURL !== undefined) return BASEURL
  else return window.location.origin + '/api'
}
